import React from 'react';

const ExportModal = ({ onClose, onExport, anonymousUserId }) => {
    const saveToLibrary = async (canvasId) => {
        const imageData = await onExport(canvasId);
        const savedMaps = JSON.parse(localStorage.getItem(`savedMaps_${anonymousUserId}`)) || [];
        savedMaps.push({
            imageData,
            savedAt: new Date().toISOString()
        });
        localStorage.setItem(`savedMaps_${anonymousUserId}`, JSON.stringify(savedMaps));
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                background: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                minWidth: '300px'
            }}>
                <h3 style={{ marginBottom: '20px' }}>Export Options</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {['left', 'right', 'both'].map(canvasId => (
                        <div key={canvasId} style={{
                            display: 'flex',
                            gap: '8px',
                            marginBottom: '12px'
                        }}>
                            <button
                                onClick={() => onExport(canvasId)}
                                style={{
                                    padding: '10px',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    background: 'white',
                                    cursor: 'pointer',
                                    color: '#4a86e8',
                                    flex: 1
                                }}
                            >
                                Download {canvasId === 'both' ? 'Both Canvases' : `${canvasId} Canvas`}
                            </button>
                        </div>
                    ))}
                    <button
                        onClick={onClose}
                        style={{
                            padding: '10px',
                            border: '1px solid #ff4444',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#ff4444',
                            marginTop: '10px',
                            cursor: 'pointer'
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal; 